<template>
<!-- 日试图 -->
<div class="dayList" :class="viewType=='agendaDay'?'day':''">
  <div class="firstTimeGap" :data-index='dataIndex' v-if="!eventDayList.length"><i class="iconfont icon-fangda" @click="openNoEventBox($event)"></i></div>
  <div  class="all draggable_box"  ref="listAll">
    <div v-for="(every,index) in eventDayList" :key="index" class="item">
      <div class="preTimeGap" :data-index='dataIndex' v-if="index==0&&every.startTime!=every.curStartTime&&isTimeGo ('preTimeGap')&&every.firtIsShow"><i @click="openFirtEventBox(every,index,$event)" class="iconfont icon-fangda"></i></div>
      <ListModesEvent :every="every" @editBox="editBox"></ListModesEvent>
      <!-- +间隔 -->
      <div class="timeGap" :data-startGap='every.endTime'  :data-endGap='every.endTime+every.gapDuration' v-if="every.gaptime&&!every.isLast" >
        <span>{{every.gaptime}} {{$t('lang.Gap')}} </span>
        <div class="operation" v-if="every.isShow">
          <i @click="createEvent(every,index,$event)" class="iconfont icon-fangda"></i>
          <time-gap-operation :eventData='every' :type='1' :curDate='curDate' :TimeQuantum='TimeQuantum'></time-gap-operation>
        </div>
      </div>
    </div>
  </div>
  <div class="lastTimeGap" :data-index='dataIndex' :style="`height:calc(100% - ${offsetHeight}px)`" v-if="eventDayList.length&& lastShow ()&&isTimeGo ('lastTimeGap')"><i class="iconfont icon-fangda" @click="openLastEventBox($event)"></i></div>
</div>
</template>
<script>
import TimeGapOperation from '@/components/common/timeGapOperation.vue'
import ListModesEvent from '@/views/Playout/common/ListModesEvent.vue'
export default {
  props: {
    // 日事件信息
    eventDayList: {
      type: Array,
      default: () => {
        []
      }
    },
    // 当前事件的索引
    dataIndex: {
      default: () => {
        null
      }
    },
    // 判断是日视图还是周视图
    viewType: {
      type: String
    },
    // 当天的开始时间
    curDate: {},
    // 选择当天的时间段
    TimeQuantum: {}
  },
  components: {
    TimeGapOperation,
    ListModesEvent
  },
  data () {
    return {
      // 当前列事件的高度
      offsetHeight: 0,
      mode: {
        0: '',
        1: 'HLD/MAN',
        2: 'EXT'
      }
    }
  },
  watch: {
    // 监听事件变化设置当前列事件的高度
    eventDayList: {
      handler () {
        if (!this.dataIndex && this.dataIndex != 0) {
          this.$nextTick(() => {
            const offsetHeight = this.$refs.listAll.offsetHeight > 720 ? 720 : this.$refs.listAll.offsetHeight
            this.offsetHeight = offsetHeight
          })
        } else {
          this.$nextTick(() => {
            const offsetHeight = this.$refs.listAll.offsetHeight - 28
            this.offsetHeight = offsetHeight
          })
        }
      },
      deep: true,
      immediate: true
    },
    'data.eventSegments' () {
      this.EventSourceKong()
    }
  },
  mounted () {
  },
  methods: {
    // 点击事件编辑弹框
    editBox (e) {
      this.$emit('fillCreateBox', e)
    },
    // 判断事件时间是否过去
    isTimeGo (type) {
      if (type == 'lastTimeGap') {
        if (new Date().getTime() > this.eventDayList[0].lastTime) {
          return false
        } else {
          return true
        }
      } else {
        if (new Date().getTime() > this.eventDayList[0].startTime) {
          return false
        } else {
          return true
        }
      }
    },
    // 判断最后一个按钮是否显示
    lastShow () {
      const lastItem = this.eventDayList[this.eventDayList.length - 1]
      if ((lastItem.startTime <= lastItem.lastTime && lastItem.lastTime <= lastItem.endTime) || lastItem.lastTime == lastItem.endTime) {
        return false
      } else {
        return true
      }
    },
    // 点击+ 创建事件
    createEvent (item, index, e) {
      const eventObj = {
        startTime: '',
        endTime: ''
      }
      if (index + 1 == this.eventDayList.length) {
        eventObj.startTime = item.endTime
        eventObj.endTime = item.endTime + 30 * 60 * 1000
      } else {
        eventObj.startTime = item.endTime
        eventObj.endTime = this.eventDayList[index + 1].startTime
      }
      eventObj.startTime = new Date(eventObj.startTime)
      eventObj.endTime = new Date(eventObj.endTime)
      this.$emit('createEvent', [eventObj, e, 1])
    },
    // 如果有事件时点第一个+
    openFirtEventBox (item, index, e) {
      // 如果preEndTime存在  说明有跨天事件
      const eventObj = {
        startTime: '',
        endTime: ''
      }
      if (item.preEndTime) {
        eventObj.startTime = item.preEndTime
        eventObj.endTime = item.startTime
      } else {
        if (index === 0) {
          eventObj.startTime = item.startTime - 30 * 60 * 1000
          eventObj.endTime = item.startTime
        }
      }
      eventObj.startTime = new Date(eventObj.startTime)
      eventObj.endTime = new Date(eventObj.endTime)
      this.$emit('createEvent', [eventObj, e, 1])
    },
    // 点击最后一个+创建事件
    openLastEventBox (e) {
      const item = this.eventDayList[this.eventDayList.length - 1]
      this.$emit('createEvent', [item, e, 2, this.dataIndex])
    },
    // 如果没有事件时点+
    openNoEventBox (e) {
      this.$emit('createEvent', [this.dataIndex, e, 3])
    },
    ClickIconCompile (item, e) {
      // 打开创建编辑框
      this.$emit('popupCreateBox', {
        e,
        event: item,
        type: 1
      })
    }
  }
}
</script>

<style  lang="less" scoped>
.firstTimeGap{
    color:  #E56464;
    text-align: left;
    padding-left: 5px;
    // height: 28px;
    line-height: 28px;
    height: 100%;
    i{
      color: #999999;
    }
  }
  .day{
    overflow-y: auto;
    height: 750px;
  }
  .all{
    .item{
      border-radius: 5px;
    .preTimeGap{
      color:  #E56464;
      text-align: right;
      padding-left: 5px;
      height: 28px;
      line-height: 28px;
      i{
        color: #999999;
        padding-right: 4px;
      }
    }
    .timeGap{
      color:  #E56464;
      text-align: left;
      padding-left: 5px;
      height: 28px;
      line-height: 28px;
      display: flex;
      justify-content: space-between;
      i{
        color: #999999;
        padding-right: 4px;
      }
      .el-dropdown{
        padding-right: 4px;
      }
    }
}
  }

.lastTimeGap{
  color:  #E56464;
  text-align: right;
  padding-left: 5px;
  height: 28px;
  line-height: 28px;
  i{
    color: #999999;
  }
}
</style>
